const shared = {
  appId: window.agI,
  apiKey: window.agSk,
  env: window.env
}

const elementsConfig = {
  ...shared,
  indexName: window.agSiS,
};

export { elementsConfig };
